/**
 * U14 F4: editor de modelos de mensagem (templates oficiais) e envio com cabeçalho, botões e variáveis nomeadas, nos três
 * idiomas (sem travessão nem emoji). As variáveis do WhatsApp ({{1}}, {{nome}}) entram por parâmetro, nunca no texto.
 */
const pt = {
  modelos: {
    novo: 'Novo modelo',
    titulo: 'Novo modelo de mensagem',
    origem: 'Origem',
    origens: { sincronizado: 'Sincronizado da Meta', criado: 'Criado no MalgoOS' },
    provedores: { meta: 'Meta', zernio: 'Zernio' },
    situacao: 'Situação',
    situacoes: {
      rascunho: 'Rascunho',
      enviando: 'Enviando para aprovação',
      erro: 'Envio recusado',
      PENDING: 'Em análise',
      APPROVED: 'Aprovado',
      REJECTED: 'Rejeitado',
      PAUSED: 'Pausado',
      DISABLED: 'Desativado',
      IN_APPEAL: 'Em recurso',
      FLAGGED: 'Aprovado, qualidade em alerta',
      REINSTATED: 'Aprovado',
      PENDING_DELETION: 'Exclusão pendente',
      LIMIT_EXCEEDED: 'Limite excedido',
      ARCHIVED: 'Arquivado',
      DELETED: 'Excluído',
    },
    qualidade: 'Qualidade',
    qualidades: { GREEN: 'Alta', YELLOW: 'Média', RED: 'Baixa', UNKNOWN: 'Sem avaliação' },
    motivo: 'Motivo da Meta',
    motivos: {
      INVALID_FORMAT: 'Formato inválido',
      INCORRECT_CATEGORY: 'Categoria incorreta',
      TAG_CONTENT_MISMATCH: 'O conteúdo não combina com a categoria',
      ABUSIVE_CONTENT: 'Conteúdo abusivo',
      SCAM: 'Suspeita de golpe',
      PROMOTIONAL: 'Conteúdo promocional',
    },
    erroEnvio: 'O provedor recusou o envio',
    categoriaMudou: 'A Meta mudou a categoria de {{antes}} para {{agora}} em {{quando}}.',
    categoriaPrevista: 'A Meta avisou que a categoria vai mudar para {{nova}}.',
    categoriaPrevistaEm: 'A Meta avisou que a categoria vai mudar para {{nova}} em {{quando}}.',
    enviadoEm: 'Enviado para aprovação em {{quando}} ({{provedor}}).',
    somenteLeitura: 'Em análise na Meta: dá para editar depois da resposta.',
    semPermissao: 'Você vê o modelo, mas não pode editar.',
    campos: {
      nome: 'Nome',
      ajudaNome: 'Minúsculas, números e _ (ex.: confirmacao_pedido). Não muda depois de enviado.',
      idioma: 'Idioma',
      categoria: 'Categoria',
      tipoCabecalho: 'Cabeçalho',
      textoCabecalho: 'Texto do cabeçalho',
      ajudaCabecalho: 'Até 60 caracteres e no máximo uma variável.',
      amostra: 'Arquivo de amostra',
      ajudaAmostra: 'A Meta pede um exemplo do arquivo na aprovação: imagem JPG ou PNG, vídeo MP4 ou PDF.',
      enviarAmostra: 'Enviar arquivo',
      amostraEnviada: 'Arquivo de amostra enviado',
      tirarAmostra: 'Tirar arquivo',
      corpo: 'Corpo',
      ajudaCorpo: 'Até 1024 caracteres. Variáveis como {{numero}} ou {{nome}}; o corpo não começa nem termina com variável.',
      inserirVariavel: 'Inserir variável',
      exemplos: 'Exemplos das variáveis',
      ajudaExemplos: 'A Meta usa os exemplos para revisar o modelo.',
      exemplo: 'Exemplo de {{variavel}}',
      rodape: 'Rodapé',
      ajudaRodape: 'Opcional, até 60 caracteres, sem variável.',
      botoes: 'Botões',
      ajudaBotoes: 'Até 10: respostas rápidas (até 10, juntas), link (até 2), ligar (1) e copiar código (1).',
      novoBotao: 'Adicionar botão',
      tipoBotao: 'Tipo do botão {{n}}',
      rotulo: 'Rótulo do botão {{n}}',
      url: 'Link do botão {{n}}',
      ajudaUrl: 'https://... Com {{variavel}} no fim, o final do link muda a cada envio.',
      exemploUrl: 'Exemplo do final do link do botão {{n}}',
      telefone: 'Telefone do botão {{n}}',
      exemploCodigo: 'Exemplo do código do botão {{n}}',
      tirarBotao: 'Tirar o botão {{n}}',
      seguranca: 'Mostrar o aviso de segurança da Meta',
      expiracao: 'Validade do código (minutos)',
      ajudaExpiracao: 'Opcional, de 1 a 90.',
      rotuloCopiar: 'Rótulo do botão de copiar (opcional)',
      ajudaAutenticacao: 'O texto do modelo de autenticação é o padrão da Meta no idioma escolhido, com o código como variável.',
    },
    tiposCabecalho: { nenhum: 'Sem cabeçalho', texto: 'Texto', imagem: 'Imagem', video: 'Vídeo', documento: 'Documento (PDF)' },
    tiposBotao: { resposta: 'Resposta rápida', link: 'Link', telefone: 'Ligar', copiar: 'Copiar código' },
    previa: 'Prévia',
    copiarCodigo: 'Copiar código',
    problemas: 'O que falta para mandar para aprovação',
    salvarRascunho: 'Salvar rascunho',
    enviarAprovacao: 'Enviar para aprovação',
    reenviar: 'Enviar de novo para aprovação',
    salvo: 'Rascunho salvo',
    enviado: 'Modelo enviado para aprovação. A situação atualiza quando a Meta responder.',
  },
  enviarModelo: {
    variavelNome: 'Variável {{nome}}',
    cabecalho: 'Variável do cabeçalho',
    cabecalhoMidia: 'Link https da mídia do cabeçalho',
    botaoLink: 'Final do link do botão {{n}}',
    botaoCodigo: 'Código do botão {{n}}',
  },
};

type Dic = typeof pt;

const en: Dic = {
  modelos: {
    novo: 'New template',
    titulo: 'New message template',
    origem: 'Source',
    origens: { sincronizado: 'Synced from Meta', criado: 'Created in MalgoOS' },
    provedores: { meta: 'Meta', zernio: 'Zernio' },
    situacao: 'Status',
    situacoes: {
      rascunho: 'Draft',
      enviando: 'Sending for review',
      erro: 'Submission refused',
      PENDING: 'Under review',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      PAUSED: 'Paused',
      DISABLED: 'Disabled',
      IN_APPEAL: 'In appeal',
      FLAGGED: 'Approved, quality warning',
      REINSTATED: 'Approved',
      PENDING_DELETION: 'Deletion pending',
      LIMIT_EXCEEDED: 'Limit exceeded',
      ARCHIVED: 'Archived',
      DELETED: 'Deleted',
    },
    qualidade: 'Quality',
    qualidades: { GREEN: 'High', YELLOW: 'Medium', RED: 'Low', UNKNOWN: 'Not rated' },
    motivo: 'Reason from Meta',
    motivos: {
      INVALID_FORMAT: 'Invalid format',
      INCORRECT_CATEGORY: 'Incorrect category',
      TAG_CONTENT_MISMATCH: 'Content does not match the category',
      ABUSIVE_CONTENT: 'Abusive content',
      SCAM: 'Suspected scam',
      PROMOTIONAL: 'Promotional content',
    },
    erroEnvio: 'The provider refused the submission',
    categoriaMudou: 'Meta changed the category from {{antes}} to {{agora}} on {{quando}}.',
    categoriaPrevista: 'Meta warned that the category will change to {{nova}}.',
    categoriaPrevistaEm: 'Meta warned that the category will change to {{nova}} on {{quando}}.',
    enviadoEm: 'Sent for review on {{quando}} ({{provedor}}).',
    somenteLeitura: 'Under review at Meta: you can edit it after the answer.',
    semPermissao: 'You can see the template but cannot edit it.',
    campos: {
      nome: 'Name',
      ajudaNome: 'Lowercase letters, numbers and _ (e.g. order_confirmation). It does not change once sent.',
      idioma: 'Language',
      categoria: 'Category',
      tipoCabecalho: 'Header',
      textoCabecalho: 'Header text',
      ajudaCabecalho: 'Up to 60 characters and at most one variable.',
      amostra: 'Sample file',
      ajudaAmostra: 'Meta asks for a sample of the file in the review: JPG or PNG image, MP4 video or PDF.',
      enviarAmostra: 'Upload file',
      amostraEnviada: 'Sample file uploaded',
      tirarAmostra: 'Remove file',
      corpo: 'Body',
      ajudaCorpo: 'Up to 1024 characters. Variables like {{numero}} or {{nome}}; the body does not start or end with a variable.',
      inserirVariavel: 'Insert variable',
      exemplos: 'Variable examples',
      ajudaExemplos: 'Meta uses the examples to review the template.',
      exemplo: 'Example of {{variavel}}',
      rodape: 'Footer',
      ajudaRodape: 'Optional, up to 60 characters, no variable.',
      botoes: 'Buttons',
      ajudaBotoes: 'Up to 10: quick replies (up to 10, together), link (up to 2), call (1) and copy code (1).',
      novoBotao: 'Add button',
      tipoBotao: 'Type of button {{n}}',
      rotulo: 'Label of button {{n}}',
      url: 'Link of button {{n}}',
      ajudaUrl: 'https://... With {{variavel}} at the end, the link ending changes on each send.',
      exemploUrl: 'Example of the link ending of button {{n}}',
      telefone: 'Phone of button {{n}}',
      exemploCodigo: 'Code example of button {{n}}',
      tirarBotao: 'Remove button {{n}}',
      seguranca: 'Show the Meta security notice',
      expiracao: 'Code validity (minutes)',
      ajudaExpiracao: 'Optional, from 1 to 90.',
      rotuloCopiar: 'Copy button label (optional)',
      ajudaAutenticacao: 'The authentication template text is the Meta default in the chosen language, with the code as the variable.',
    },
    tiposCabecalho: { nenhum: 'No header', texto: 'Text', imagem: 'Image', video: 'Video', documento: 'Document (PDF)' },
    tiposBotao: { resposta: 'Quick reply', link: 'Link', telefone: 'Call', copiar: 'Copy code' },
    previa: 'Preview',
    copiarCodigo: 'Copy code',
    problemas: 'What is missing before sending for review',
    salvarRascunho: 'Save draft',
    enviarAprovacao: 'Send for review',
    reenviar: 'Send for review again',
    salvo: 'Draft saved',
    enviado: 'Template sent for review. The status updates when Meta answers.',
  },
  enviarModelo: {
    variavelNome: 'Variable {{nome}}',
    cabecalho: 'Header variable',
    cabecalhoMidia: 'https link of the header media',
    botaoLink: 'Link ending of button {{n}}',
    botaoCodigo: 'Code of button {{n}}',
  },
};

const es: Dic = {
  modelos: {
    novo: 'Nueva plantilla',
    titulo: 'Nueva plantilla de mensaje',
    origem: 'Origen',
    origens: { sincronizado: 'Sincronizada de Meta', criado: 'Creada en MalgoOS' },
    provedores: { meta: 'Meta', zernio: 'Zernio' },
    situacao: 'Situación',
    situacoes: {
      rascunho: 'Borrador',
      enviando: 'Enviando a revisión',
      erro: 'Envío rechazado',
      PENDING: 'En revisión',
      APPROVED: 'Aprobada',
      REJECTED: 'Rechazada',
      PAUSED: 'Pausada',
      DISABLED: 'Desactivada',
      IN_APPEAL: 'En apelación',
      FLAGGED: 'Aprobada, calidad en alerta',
      REINSTATED: 'Aprobada',
      PENDING_DELETION: 'Eliminación pendiente',
      LIMIT_EXCEEDED: 'Límite excedido',
      ARCHIVED: 'Archivada',
      DELETED: 'Eliminada',
    },
    qualidade: 'Calidad',
    qualidades: { GREEN: 'Alta', YELLOW: 'Media', RED: 'Baja', UNKNOWN: 'Sin evaluación' },
    motivo: 'Motivo de Meta',
    motivos: {
      INVALID_FORMAT: 'Formato no válido',
      INCORRECT_CATEGORY: 'Categoría incorrecta',
      TAG_CONTENT_MISMATCH: 'El contenido no coincide con la categoría',
      ABUSIVE_CONTENT: 'Contenido abusivo',
      SCAM: 'Sospecha de estafa',
      PROMOTIONAL: 'Contenido promocional',
    },
    erroEnvio: 'El proveedor rechazó el envío',
    categoriaMudou: 'Meta cambió la categoría de {{antes}} a {{agora}} el {{quando}}.',
    categoriaPrevista: 'Meta avisó que la categoría cambiará a {{nova}}.',
    categoriaPrevistaEm: 'Meta avisó que la categoría cambiará a {{nova}} el {{quando}}.',
    enviadoEm: 'Enviada a revisión el {{quando}} ({{provedor}}).',
    somenteLeitura: 'En revisión en Meta: se puede editar después de la respuesta.',
    semPermissao: 'Ves la plantilla, pero no puedes editarla.',
    campos: {
      nome: 'Nombre',
      ajudaNome: 'Minúsculas, números y _ (ej.: confirmacion_pedido). No cambia después de enviada.',
      idioma: 'Idioma',
      categoria: 'Categoría',
      tipoCabecalho: 'Encabezado',
      textoCabecalho: 'Texto del encabezado',
      ajudaCabecalho: 'Hasta 60 caracteres y como máximo una variable.',
      amostra: 'Archivo de muestra',
      ajudaAmostra: 'Meta pide un ejemplo del archivo en la revisión: imagen JPG o PNG, video MP4 o PDF.',
      enviarAmostra: 'Subir archivo',
      amostraEnviada: 'Archivo de muestra subido',
      tirarAmostra: 'Quitar archivo',
      corpo: 'Cuerpo',
      ajudaCorpo: 'Hasta 1024 caracteres. Variables como {{numero}} o {{nome}}; el cuerpo no empieza ni termina con una variable.',
      inserirVariavel: 'Insertar variable',
      exemplos: 'Ejemplos de las variables',
      ajudaExemplos: 'Meta usa los ejemplos para revisar la plantilla.',
      exemplo: 'Ejemplo de {{variavel}}',
      rodape: 'Pie',
      ajudaRodape: 'Opcional, hasta 60 caracteres, sin variable.',
      botoes: 'Botones',
      ajudaBotoes: 'Hasta 10: respuestas rápidas (hasta 10, juntas), enlace (hasta 2), llamar (1) y copiar código (1).',
      novoBotao: 'Agregar botón',
      tipoBotao: 'Tipo del botón {{n}}',
      rotulo: 'Texto del botón {{n}}',
      url: 'Enlace del botón {{n}}',
      ajudaUrl: 'https://... Con {{variavel}} al final, el final del enlace cambia en cada envío.',
      exemploUrl: 'Ejemplo del final del enlace del botón {{n}}',
      telefone: 'Teléfono del botón {{n}}',
      exemploCodigo: 'Ejemplo del código del botón {{n}}',
      tirarBotao: 'Quitar el botón {{n}}',
      seguranca: 'Mostrar el aviso de seguridad de Meta',
      expiracao: 'Validez del código (minutos)',
      ajudaExpiracao: 'Opcional, de 1 a 90.',
      rotuloCopiar: 'Texto del botón de copiar (opcional)',
      ajudaAutenticacao: 'El texto de la plantilla de autenticación es el predeterminado de Meta en el idioma elegido, con el código como variable.',
    },
    tiposCabecalho: { nenhum: 'Sin encabezado', texto: 'Texto', imagem: 'Imagen', video: 'Video', documento: 'Documento (PDF)' },
    tiposBotao: { resposta: 'Respuesta rápida', link: 'Enlace', telefone: 'Llamar', copiar: 'Copiar código' },
    previa: 'Vista previa',
    copiarCodigo: 'Copiar código',
    problemas: 'Lo que falta para enviar a revisión',
    salvarRascunho: 'Guardar borrador',
    enviarAprovacao: 'Enviar a revisión',
    reenviar: 'Enviar de nuevo a revisión',
    salvo: 'Borrador guardado',
    enviado: 'Plantilla enviada a revisión. La situación se actualiza cuando Meta responda.',
  },
  enviarModelo: {
    variavelNome: 'Variable {{nome}}',
    cabecalho: 'Variable del encabezado',
    cabecalhoMidia: 'Enlace https del archivo del encabezado',
    botaoLink: 'Final del enlace del botón {{n}}',
    botaoCodigo: 'Código del botón {{n}}',
  },
};

export const u14f4 = { pt, en, es };
